<link rel="stylesheet" type="text/css" [href]="overrideCssUrl | safeUrl">

<loan-update-conflict-notification></loan-update-conflict-notification>

<div #stickyHeader style="position: sticky !important; z-index: 1049; top: 0">
  @if (userIsImpersonating) {
    <div class="alert alert-light fade show mb-0 navbar-expand-lg" role="alert"
      id="alert-window" style="border-bottom: 2px solid rgb(46, 168, 226) !important;">
      <div class="media">
        <i style="color:rgb(46, 168, 226)" class="fas fa-diagnoses alert-icon align-self-center font-30 me-3"></i>
        <div class="media-body align-self-center">
          @if (isImpersonatingForLoan) {
            <span class="mb-1 fw-bold mt-0">You as an Admin are currently viewing the loan in impersonation mode.</span><br>
          } @else {
            <span class="mb-1 fw-bold mt-0">You as an Admin are currently viewing the TPO portal in impersonation mode.</span><br>
          }
          <span> <a (click)="onStopImpersonatingClicked()" style="color:rgb(46, 168, 226)" target="_blank">Click Here To
          Stop Impersonating</a></span>
        </div>
      </div>
    </div>
  }

  <div class="topbar" id="tpo-header">
    <div class="container container-width">
      <tpo-header
        (notificationsClicked)="onNotificationsClicked($event)"
        (alertsCreated)="onAlertsCreated($event)"
        (mentionsClicked)="onMentionsClicked($event)">
      </tpo-header>
    </div>
  </div>
</div>

<router-outlet></router-outlet>

<div class="container-fluid footer-style">
  <div class="page-wrapper">
    <div class="row">
      <div class="col-md-12">
        @if (tpoConfig && tpoConfig.footerMergedHtml) {
          <div class="text-center text-sm-start mb-0 ms-2"
          [innerHtml]="tpoConfig.footerMergedHtml"></div>
        }
        @if (!tpoConfig || !tpoConfig.footerMergedHtml) {
          <div class="text-center text-sm-start mb-0 ms-2">
            &copy;
            {{currentYear}} Lodasoft
          </div>
        }
        @if (isCompanySmartfi) {
          <iframe style="width:1px; height: 1px; opacity: 0;" src="https://www.smartfihomeloans.com/resources-auth-frame/"></iframe>
        }
      </div>
    </div>
  </div>
</div>

<favicon-loader [faviconUrl]="faviconUrl"></favicon-loader>

<drawer #mentionsDrawer [title]="'Mentions'" [name]="'mentionsDrawer'" [templateRef]="mentionsDrawerContentRef"
  [options]="mentionsDrawerOptions" (closed)="onMentionsDrawerClosed()">
</drawer>
<ng-template #mentionsDrawerContentRef>
  <mentions-stream (mentionClicked)="onMentionClicked($event)"></mentions-stream>
</ng-template>

<drawer [title]="'Alerts & Notifications'" #alerts [name]="'alertsDrawer'" [templateRef]="alertsDrawerContentRef"
  [options]="alertsDrawerOptions" (closed)="onNotificationsDrawerClosed()">
</drawer>
<ng-template #alertsDrawerContentRef>
  <notifications-list [data]="notifications" (clickedGotoDetails)="notificationDetails($event)">
  </notifications-list>
</ng-template>

<drawer [title]="'Loan Activity'" [options]="loanActivityDrawerOptions" [name]="'loanActivityInternalMessageDrawer'"
  [templateRef]="loanActivityRef" (closed)="onMentionDetailsDrawerClosed()">
</drawer>
<ng-template #loanActivityRef>
  <div class="drawer-fill">
    @if (mentionMessageScope == 'InternalMessage') {
      <loan-activity class="drawer-fill" [refreshMentions]="refreshMentions" [idOfMessageToScrollTo]="messageId" [showFilters]="true"
        [activityTab]="'InternalMessage'" [appId]="mentionApplicationId" [mentionTrackingGuid]="mentionTrackingGuid"
        >
      </loan-activity>
    }
  </div>
</ng-template>

<drawer [title]="'Editing Task'" [options]="taskEditorDrawerOptions" [name]="'taskEditorDrawer'"
[templateRef]="taskEditorRef" (closed)="onMentionDetailsDrawerClosed()"></drawer>
<ng-template #taskEditorRef>
  @if (taskMentionTrackingUrl) {
    <img [src]="taskMentionTrackingUrl" class="tracker-image" width="1" height="1">
  }
  @if (mentionMessageScope == 'TaskNote' && mentionLoanDocTask) {
    <task-editor style="height: 90%"
    [hostedInModal]="false" [refreshMentions]="refreshMentions" [task]="mentionLoanDocTask"></task-editor>
  }
</ng-template>

